import React from 'react'

const Dashboard = () => {
  return (
    <div>
      <h1>Hye Dashboard Coming Soonsss</h1>
    </div>
  )
}

export default Dashboard
